// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"18a2a3ab","716":"22e553fb","758":"f0428862","810":"bbf5fadf"}[chunkId] + ".chunk.js";
};